import toast from 'react-hot-toast';
import type { CelebrationPersona, EnrichedCelebration } from './celebration.types';
import { CELEBRATION_EYEBROW, CELEBRATION_PRIMARY_CTA, CELEBRATION_SECONDARY_CTA } from './celebration.tokens';

const TOAST_DURATION_MS = 5000;

function Tier1ToastContent({
  item,
  persona,
  onDismiss,
}: {
  item: EnrichedCelebration;
  persona: CelebrationPersona;
  onDismiss: () => void;
}) {
  const accent = persona === 'seller' ? 'border-l-purple-400' : 'border-l-fuchsia-400';
  const chip = persona === 'seller' ? 'text-purple-700' : 'text-fuchsia-700';

  return (
    <div
      className={`pointer-events-auto w-[min(100vw-2rem,22rem)] rounded-xl border border-slate-200/80 bg-white p-4 shadow-lg ring-1 ring-slate-900/[0.04] border-l-4 ${accent}`}
      data-testid="celebration-tier1-toast"
    >
      <p className={`text-[10px] font-semibold uppercase tracking-wide ${chip}`}>{item.eyebrow}</p>
      <p className="mt-1 text-sm font-semibold text-slate-900">{item.title}</p>
      <p className="mt-1 text-xs leading-relaxed text-slate-600">{item.whyItMatters}</p>
      {item.xp && item.xp > 0 ? (
        <p className="mt-2 text-[11px] font-medium text-slate-500">+{item.xp} activity points</p>
      ) : null}
      <button
        type="button"
        onClick={onDismiss}
        className={`mt-3 ${CELEBRATION_SECONDARY_CTA[persona]} w-full py-2 text-xs`}
      >
        {item.secondaryCtaLabel}
      </button>
    </div>
  );
}

export function showCelebrationToasts(
  items: EnrichedCelebration[],
  persona: CelebrationPersona,
  onDismissItem: (id: string) => void,
) {
  for (const item of items) {
    const dismissIds = item.sourceIds ?? [item.id];
    toast.custom(
      (t) => (
        <Tier1ToastContent
          item={item}
          persona={persona}
          onDismiss={() => {
            toast.dismiss(t.id);
            for (const id of dismissIds) onDismissItem(id);
          }}
        />
      ),
      { duration: TOAST_DURATION_MS, position: 'top-right' },
    );
    setTimeout(() => {
      for (const id of dismissIds) onDismissItem(id);
    }, TOAST_DURATION_MS);
  }
}

export { CELEBRATION_PRIMARY_CTA };
